var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.hideBlock}},[_c('icon',{staticClass:"button cursor-pointer rotating",class:{ toggled: _vm.isToggled() },attrs:{"type":"arrow-to-up","color":_vm.color,"size":16}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }